<script setup lang="ts">
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import AlertBox from '@/components/Elements/Alerts/AlertBox.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { handleNext } from '../tutorialSteps'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_alliances')
}

const isOnAlliancesSection = computed(() => {
  return route.path.startsWith('/diplomacy/alliances')
})

const goToAlliances = () => {
  router.push('/diplomacy/alliances')
}
</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/government.webm"
  >
    <template #text>
      <p class="pb-2">
        {{ t('tutorial.diplomacy.alliances.powerful') }}
      </p>
      <p class="pb-2">
        {{ t('tutorial.diplomacy.alliances.byJoining') }}
      </p>
      <p class="pb-2">
        {{ t('tutorial.diplomacy.alliances.remember') }}
      </p>
    </template>

    <template #alerts>
      <AlertBox type="info">
        {{ t('tutorial.diplomacy.alliances.clickAlliances') }}
      </AlertBox>
    </template>

    <template #buttons>
      <ActionButton v-if="!isOnAlliancesSection" @click="goToAlliances" class="mr-2">
        {{ t('tutorial.diplomacy.alliances.viewAlliances') }}
      </ActionButton>
      <ActionButton @click="handleNextStep">
        {{ t('tutorial.diplomacy.alliances.gotIt') }}
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss">

</style>